function roughSizeTree (object) {
  const objectSet = new Set()
  const result = {}
  const stack = [{ target: result, value: object, name: 'root' }]

  let total = 0
  while (stack.length > 0) {
    const { target, value, name } = stack.pop()

    switch (typeof value) {
      case 'boolean':
        target[name] = { type: 'bool', size: 4 }
        total += 4
        break

      case 'string':
        target[name] = { type: 'string', size: value.length * 2 }
        total += value.length * 2
        break

      case 'function':
        target[name] = { type: 'function', size: value.length * 2 }
        total += value.length * 2
        break

      case 'number':
        target[name] = { type: 'number', size: 8 }
        total += 8
        break

      case 'object':
        if (!objectSet.has(value)) {
          objectSet.add(value)
          target[name] = {}
          for (const prop in value) {
            try {
              stack.push(
                { target: target[name], value: value[prop], name: prop }
              )
            } catch (e) {
            }
          }
        }
        break

      default:
    }
  }

  return {
    source: object,
    tree: result,
    size: {
      total,
      kb: total / 1024,
      mb: total / (1024 * 1024)
    }
  }
}

function hasDeps (object) {
  return object != null && object.__ob__ != null
}

function listMembersWithDeps (object) {
  const result = []
  for (let key in object) {
    const value = object[key]
    if (value != null && hasDeps(value)) {
      result.push(key)
    }
  }
  return result
}

export default {
  roughSizeTree,
  hasDeps,
  listMembersWithDeps
}
